<template>
  <div>
    <div v-if="isAdmin">
      <v-btn @click="logoutAdmin()" small depressed>Admin Log Out</v-btn>
    </div>
    <div v-else-if="tyingToLogIn">
      <v-dialog v-model="dialog" width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small v-bind="attrs" v-on="on" depressed> Admin Login </v-btn>
        </template>

        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Admin Login
          </v-card-title>

          <v-card-text class="pa-4">
            <v-alert v-if="failure" type="error"
              >You are a failure
              <v-icon class="ml-2">mdi-emoticon-frown-outline</v-icon></v-alert
            >
            <v-text-field
              v-model="username"
              placeholder="Username"
            ></v-text-field>
            <v-text-field
              v-model="password"
              placeholder="Password"
            ></v-text-field>
            <v-btn @click="adminLogin()" depressed color="primary"
              >Log in</v-btn
            >
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false"> Cancel </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import HashParserMixin from "@/assets/js/HashParserMixin";
import AdminMixin from "@/assets/js/AdminMixin";

export default {
  name: "AdminLogin",
  mixins: [HashParserMixin, AdminMixin],
  props: {},
  data: function () {
    return {
      dialog: false,
      tyingToLogIn: false,
      username: null,
      password: null,
      failure: false,
      // isAdmin is in AdminMixin
    };
  },
  methods: {
    // adminLogout() {
    //   this.setAdmin(null); // from adminMixin
    //   //this.$store.dispatch("setAdmin", null);
    // },
    adminLogin() {
      // console.log("loggin' in");
      let u = this.username;
      let p = this.password;
      const d = new Date();
      let day = d.getDate();
      let month = d.getMonth();
      let concat = `${month} ${day}`;
      // console.log(concat);
      if (p == concat) {
        this.setStore(u);
      } else {
        this.failure = true;
      }
    },
    setStore(username) {
      this.setAdmin(username);
      //this.$store.dispatch("setAdmin", username);
      this.dialog = false;
    },
  },
  computed: {},
  mounted: function () {
    // look for admin key in the hash (calls function in hashParserMixin)
    this.tyingToLogIn = this.hashValForKey("admin");
  },
};
</script>

<style scoped></style>
